export default {
  settingGroup: {
    country: 'Country',
    bank: 'Bank',
    ownership: 'Ownership',
  },
}